import { MetricCardNumber } from './MetricCardNumber'
import { MetricCardRoot } from './MetricCardRoot'
import { MetricCardTitle } from './MetricCardTitle'

export const MetricCard = {
  Root: MetricCardRoot,
  Title: MetricCardTitle,
  Number: MetricCardNumber,
}
